import * as React from "react";

export const IconContentFileCopy = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_41279_52106)">
      <path
        d="M13.3337 0.833984L3.33366 0.833984C2.41699 0.833984 1.66699 1.58398 1.66699 2.50065L1.66699 14.1673H3.33366L3.33366 2.50065L13.3337 2.50065V0.833984ZM12.5003 4.16732L17.5003 9.16732L17.5003 17.5007C17.5003 18.4173 16.7503 19.1673 15.8337 19.1673L6.65866 19.1673C5.74199 19.1673 5.00033 18.4173 5.00033 17.5007L5.00866 5.83398C5.00866 4.91732 5.75033 4.16732 6.66699 4.16732L12.5003 4.16732ZM11.667 10.0007H16.2503L11.667 5.41732L11.667 10.0007Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_41279_52106">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
